module.exports = __webpack_public_path__ + "img/客户案例-小房书bg@2x.7817040f.png";